// i18next 初始化：繁中/简中/英，浏览器语言自动探测
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { zhCN } from './zh-CN';
import { zhTW } from './zh-TW';
import { en } from './en';

export type AppLang = 'zh-CN' | 'zh-TW' | 'en';
export const LANG_OPTIONS: { value: AppLang; label: string }[] = [
  { value: 'zh-CN', label: '简体' },
  { value: 'zh-TW', label: '繁體' },
  { value: 'en', label: 'English' },
];

function detectLang(): AppLang {
  const saved = localStorage.getItem('wesc_lang');
  if (saved === 'zh-CN' || saved === 'zh-TW' || saved === 'en') return saved;
  const nav = navigator.language || 'en';
  if (nav.startsWith('zh')) {
    if (/TW|HK|Hant/i.test(nav)) return 'zh-TW';
    return 'zh-CN';
  }
  return 'en';
}

export const resources = {
  'zh-CN': { translation: zhCN },
  'zh-TW': { translation: zhTW },
  en: { translation: en },
} as const;

void i18n.use(initReactI18next).init({
  resources,
  lng: detectLang(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('wesc_lang', lng);
});

export default i18n;
